var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3063 0.0946913C11.4877 0.445347 8.74045 1.54081 6.43056 3.23507C5.69191 3.77683 4.21722 5.17202 3.62939 5.88528C1.74432 8.1723 0.498752 11.0726 0.0780293 14.1544C-0.0401037 15.0203 -0.0208242 17.1545 0.113685 18.0958C0.436671 20.3561 1.39655 22.9339 2.57185 24.6968C5.16809 28.5913 9.23002 31.1565 13.9303 31.8696C14.9646 32.0266 17.5466 32.046 18.6127 31.905C26.1961 30.9014 31.2382 25.6617 31.9419 18.0535C32.0717 16.6487 31.9737 14.1995 31.75 13.2619L31.7109 13.098H24.008H16.3051V16.1944V19.2908H20.697C24.1979 19.2908 25.0888 19.3096 25.0888 19.3833C25.0888 19.6226 24.7546 20.6126 24.4924 21.1504C23.7822 22.6068 22.5328 23.8311 20.9457 24.6257C18.229 25.9859 14.7905 26.0209 12.1321 24.7154C10.3208 23.826 8.70241 22.272 7.80394 20.5596C7.19854 19.4057 6.92691 18.675 6.75005 17.7244C6.39558 15.8196 6.59589 14.1029 7.3757 12.3624C8.02711 10.9087 8.68722 9.97818 9.80632 8.93642C11.5933 7.27297 13.8512 6.39637 16.3512 6.39557C18.568 6.39484 20.4471 7.04376 22.1394 8.39437L22.577 8.74357L24.9097 6.46128C27.1658 4.25396 27.2382 4.17441 27.1146 4.0378C26.8874 3.78637 25.6498 2.84755 24.9948 2.42965C23.7381 1.62794 21.8759 0.839716 20.3248 0.45307C18.6651 0.0393936 16.0179 -0.118267 14.3063 0.0946913Z",
    fill: "url(#paint0_radial_797_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_797_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3548 32) rotate(-73.8108) scale(33.3213 31.3295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.65497c2f89bbf274f295388dcaca7d92.svg";
export { ForwardRef as ReactComponent };